// Shared Dagre layout spacing config.
// Keep this as the single source of truth so all graph views stay consistent.

export const EDGE_LABEL_MIN_SPACE = 100; // label pill max width (~70px) + padding

export const getDagreBaseSpacing = (direction = "TB") => {
    const isHorizontal = direction === "LR";
    return {
        nodesep: isHorizontal ? 70 : 80,
        ranksep: EDGE_LABEL_MIN_SPACE,
    };
};

export const getAdminDagreSpacing = ({ direction = "LR", nodeCount = 0 } = {}) => {
    const base = getDagreBaseSpacing(direction);

    // Admin graphs can get very large; add extra spacing while never going below the base spacing.
    const dynamicRankSep = nodeCount > 100 ? 150 : nodeCount > 50 ? 120 : 100;
    const dynamicNodeSep = nodeCount > 100 ? 80 : nodeCount > 50 ? 60 : 50;

    return {
        nodesep: Math.max(base.nodesep, dynamicNodeSep),
        ranksep: Math.max(base.ranksep, dynamicRankSep),
    };
};
